{
  "journalAudit.action.platform.identity_provider_configured": "Platform identity provider connected",
  "journalAudit.action.platform.instance_updated": "Instance and self-service sign-up updated",
  "journalAudit.action.platform.mail_tested": "Test email sent",
  "journalAudit.action.platform.outbound_settings_updated": "Outbound flows and outgoing mail updated",
  "journalAudit.action.platform.settings_updated": "General platform settings updated",
  "journalAudit.action.platform.siem_configured": "Log export to the SIEM saved",
  "journalAudit.action.platform.siem_suspended": "Log export to the SIEM suspended or resumed",
  "journalAudit.action.platform.siem_tested": "SIEM export tested"
}
